export enum FacilityTypeEnum {
  other = 0,
  meetingRoom = 1,
  silenceSpace = 2,
  beamer = 3,
  car = 4,
  bicycle = 5,
  chargingStation = 6,
  parking = 7,
  display = 8,
}

export function getFacilityTypeFromString(
  facilityTypeString: string,
): FacilityTypeEnum {
  switch (facilityTypeString) {
    case 'meetingRoom':
      return FacilityTypeEnum.meetingRoom;
    case 'silenceSpace':
      return FacilityTypeEnum.silenceSpace;
    case 'beamer':
      return FacilityTypeEnum.beamer;
    case 'car':
      return FacilityTypeEnum.car;
    case 'bicycle':
      return FacilityTypeEnum.bicycle;
    case 'chargingStation':
      return FacilityTypeEnum.chargingStation;
    case 'parking':
      return FacilityTypeEnum.parking;
    case 'display':
      return FacilityTypeEnum.display;

    default:
      return FacilityTypeEnum.other;
  }
}
